const reSizeBackground = (sprite, w, h)=>{

    let imgSize = {w:1920, h:1080};//{w:sprite.texture.width, h:sprite.texture.height};
    let spRatio= imgSize.w / imgSize.h,
        conRatio = w / h,
        scale = 1,
        pos = new PIXI.Point(0, 0);
        if(conRatio > spRatio){
            scale = w / imgSize.w;
            pos.y = -((imgSize.h * scale)-h)/2;
        }else{
            scale = h / imgSize.h;
            pos.x = -((imgSize.w * scale)-w)/2;
        }

        sprite.scale.x = scale;
        sprite.scale.y = scale;


        sprite.position.x = pos.x;
        sprite.position.y = pos.y;
    return;
}
const reSizeIeBackground = (sprite, w, h)=>{
    let imgSize = {w:1920, h:1080};//{w:sprite.texture.width, h:sprite.texture.height};
    let spRatio= imgSize.w / imgSize.h,
        conRatio = sprite.offsetWidth / sprite.offsetHeight,
        setWidth =0,
        setHeight = 0;

    if(conRatio < spRatio){
        setWidth = sprite.offsetHeight * imgSize.w / imgSize.h;
        setHeight = sprite.offsetHeight;
    }else{
        setWidth = sprite.offsetWidth;
        setHeight = sprite.offsetWidth * imgSize.h / imgSize.w;
    }
    sprite.width = setWidth;
    sprite.height = setHeight;
    return;
}
const rePostionContents = (obj, nW, nH, cW, cH, fixedY = false)=>{
    obj.position.x = nW/2 - cW/2;
    if(!fixedY)obj.position.y = nH/2 - cH/2;
    return;
}
export {reSizeBackground, reSizeIeBackground, rePostionContents}